export default defineNuxtPlugin(() => {
  const { upload } = useUploadUtils()

  return {
    provide: {
      upload,
    },
  }
})
